import React, {useContext, useState} from 'react';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { UserContext } from '../context/UserContextProvider';
// Shared copy helper for sponsor-/vendor-aware text
import { getStepTextWithVars } from '../copy/copyHelpers';
import { useHistory } from "react-router-dom";
import Reminder from '../pages/tools/Reminder'
// import GreyCard from '../pages/tools/GreyCard'
import RedText from './tools/RedText';
import useDisableBackButton from "./hooks/useDisableBackButton";
import useSetCurrentStep from './hooks/useSetCurrentStep';

const EnterPatients = () => {

    const [isChecked, setIsChecked] = useState(false)
    const { setCurrentStep, deadline, isSampleTest, sampleTestDeadline, setSampleTestDeadline, allTimeoutsAllowed,
            ttGroup, ehrVendor, testType } = useContext(UserContext);

    const history = useHistory();
    
    useDisableBackButton()    // Disable the browser's back button 
    useSetCurrentStep("ENTER_PATIENTS", 2) // post step to server on load

    const handleAdvance = () => {
        // set current step to next step
        setCurrentStep('/testpdf'); 
        // if this is a sample test, reset the deadline
        if (isSampleTest) {setSampleTestDeadline()}
        // redirect to next step
        history.push('/testpdf');
    }

    const buttonStyle = {
        marginTop: '1em',
        fontWeight: '300'
    }  

    // Determine which deadline string to substitute in copy
    const deadlineString = isSampleTest ? sampleTestDeadline : deadline;

    // Fetch step-specific bullet text via the shared helper
    const sectionHtmlArray = getStepTextWithVars({
        ttGroup: ttGroup || 'default',
        ehrVendor: ehrVendor || 'default',
        testType: testType || 'default',
        step: 'step2',
        timeoutsOn: allTimeoutsAllowed
    }, { deadline: deadlineString });
    // The helper currently returns an array (1 element) for consistency.
    const sectionHtml = sectionHtmlArray.join('');

    // DEBUG: Log full context to help diagnose dynamic copy issues
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.debug('[EnterPatients] copy debug', {
            sponsorOrg: ttGroup,
            ehrVendorRaw: ehrVendor,
            vendorKey: ehrVendor != null ? String(ehrVendor) : 'default',
            testType,
            timeoutsOn: allTimeoutsAllowed,
            selectedText: sectionHtml
        });
    }

    return(
        <Container className="mt-3 mb-5 pt-3 pb-3"
        style={{fontWeight: "300"}}>
            <Row>
                <Col sm={12}>
                    <h1>Step 2 of 7: Enter Test Patients</h1>
                    <hr />
                    <Reminder />
                    {/* LF requested removal of this element in April 1 text updates */}
                    {/* <GreyCard text="If you have not already entered the Test Patients into your hospital system(s), please do so now." /> */}

                    <div dangerouslySetInnerHTML={{ __html: sectionHtml }} />
                    <RedText />
                    <Card>
                        <Card.Body>
                            <Form>
                                <Form.Check 
                                    type="checkbox" 
                                    label={<strong>Yes, I have entered the Test Patients and I am ready to begin Step 3.</strong>}
                                    onClick={() => setIsChecked(!isChecked)}
                                    checked={isChecked}
                                    />
                            </Form>
                        </Card.Body>
                    </Card>
                    <div style={{textAlign: 'center'}}>
                        <Button
                        style={buttonStyle}
                        disabled={isChecked ? false : true}
                        onClick={handleAdvance}
                        className="px-3"
                        variant="info"
                        >
                        Proceed to Step 3
                        </Button>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default EnterPatients